import { WebhookDelivery } from '@/types/alert';

function parseRequestBody(requestBody: string): unknown {
    try {
        return JSON.parse(requestBody);
    } catch {
        return null;
    }
}

export function formatRequestBody(requestBody: string): string {
    const parsed = parseRequestBody(requestBody);
    return parsed === null ? requestBody : JSON.stringify(parsed, null, 2);
}

export function findFirstDeliveriesToNewUrl(
    deliveries: WebhookDelivery[],
): Set<string> {
    return new Set(
        deliveries
            .filter(
                (delivery, index) =>
                    index < deliveries.length - 1 &&
                    delivery.url !== deliveries[index + 1].url,
            )
            .map((delivery) => delivery.id),
    );
}
